/*
 * 首屏加载画面的卸载时机。
 *
 * ## 为什么不是「React 首帧就淡出」
 *
 * 曾经是：`main.tsx` 在双 rAF 之后就把 `#boot` 淡出。问题是那一刻会话还没判定，
 * 紧接着 `RequireSession` 画的是 `.app-boot`——一块和 boot 同色的纯色底，
 * 上面**一只蝴蝶都没有**。于是用户看到的是「五只蝴蝶飞着 → 突然全没了 → 又出现界面」。
 * 这一帧正常 100–500ms，`app/session` 超时上限 8 秒，弱网时是一段很长的空白。
 *
 * 现在改成：**会话判定出结果之后才淡出**。首屏画面就一直是首屏画面，
 * 中间没有断层，也不需要在 React 侧再实现一份蝴蝶——那会变成第二处定义。
 *
 * ## 兜底
 *
 * `session.tsx` 的每条分支（成功 / unauthorized / forbidden / 降级）都会把
 * `status` 从 `checking` 挪走，所以正常情况下一定会调到这里。但**不能只依赖它**：
 * 万一将来有人加了一条不落地的分支，用户就永远停在加载页。`main.tsx` 里挂了
 * 一个硬上限作为第二道保险。
 */

/** 只允许生效一次：会话回调与硬上限可能都触发。 */
let dismissed = false;

export function dismissBoot(): void {
  if (dismissed) return;
  dismissed = true;

  // 双 rAF：第一帧提交 DOM，第二帧确认已经绘制，此时再淡出才不会闪白。
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const boot = document.getElementById("boot");
      if (!boot) return;
      boot.classList.add("is-dismissed");
      boot.addEventListener("transitionend", () => boot.remove(), {
        once: true,
      });
      // transitionend 在 prefers-reduced-motion 下可能不触发，加个保险。
      window.setTimeout(() => boot.remove(), 1200);
    });
  });
}
